var React = require('react');

function BoneBreak (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M598.88 171.44A74.38 74.38 0 0 1 640 238v7.64a74.38 74.38 0 0 1-144.94 23.53l-7.75-23.26A32 32 0 0 0 457 224H352l32-64-32-64h105a32 32 0 0 0 30.36-21.88l7.75-23.26A74.38 74.38 0 0 1 640 74.39V82a74.39 74.39 0 0 1-41.12 66.53 12.79 12.79 0 0 0 0 22.91z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 282.51L256 256l-26.5-64-63 63a32 32 0 0 1-36.94 6l-21.93-11a74.39 74.39 0 0 0-85.84 119.13l5.4 5.4a74.39 74.39 0 0 0 76.12 18 12.79 12.79 0 0 1 16.18 16.18 74.39 74.39 0 0 0 18 76.12l5.4 5.4A74.39 74.39 0 0 0 262 404.33l-11-21.93a32 32 0 0 1 6-36.94z","className":"fa-primary","key":2})]);
}

BoneBreak.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = BoneBreak;

BoneBreak.default = BoneBreak;
